import Layout from "../components/layout";
import {GetStaticProps} from "next";
import LeadingCompany from "../components/v2/leading-company-cta";
import Card from "../components/v2/cards/card";
import BookADemo from "../components/v2/form/book-a-demo";
import TestimonialsDemoPage from "../components/v2/mw-carousel/testimonial-demo-page";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../next-i18next.config";
import { useTranslation } from "next-i18next";
import "../styles/scss/contact-us.module.scss";

const DemoRequest = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <Layout
        isHomePage={false}
        pageTitle={"Request a Demo | Middleware"}
        ogImage={"/images/demo-request-thumbnail.png"}
        uri={"/demo-request/"}
        metaTitle={"Request a Demo | Middleware"}
        metaDesc={
          "Request a demo of Middleware’s cloud observability platform to optimize infrastructure and enhance user experience."
        }
        metaRobotsNoindex={"index"}
        metaRobotsNofollow={"follow"}
      >
        <div className="middle-wrapper contact-us book-demo-page">
          <div className={"container"}>
            <div className={"contact"}>
              <div className={"d-flex"}>
                <div className={"left-block"}>
                  <h1>
                    {t("demoRequest.hero.title")}{" "}
                    <span className={"text-gradient"}>{t("demoRequest.hero.titleHighlight")}</span>
                  </h1>
                  <LeadingCompany />

                  <TestimonialsDemoPage />
                </div>

                <div className={"right-block"}>
                  <BookADemo />
                </div>
              </div>
            </div>
          </div>
          <section className={"mw-card"}>
            <div className={"container"}>
              <div className={"section-tag testimonial pd-right"}>
                {t("demoRequest.impact.sectionTag")}
              </div>
              <h2>
                {t("demoRequest.impact.title")}
                <span className={"text-gradient"}>{t("demoRequest.impact.titleHighlight")}</span>
                {t("demoRequest.impact.titleSuffix")}
              </h2>
              <div className={"d-flex card-items"}>
                <Card
                  title={t("demoRequest.impact.cards.card1.title")}
                  heading={t("demoRequest.impact.cards.card1.heading")}
                  description={t("demoRequest.impact.cards.card1.description")}
                  isHeading={true}
                />
                <Card
                  title={t("demoRequest.impact.cards.card2.title")}
                  heading={t("demoRequest.impact.cards.card2.heading")}
                  description={t("demoRequest.impact.cards.card2.description")}
                  isHeading={true}
                />
                <Card
                  title={t("demoRequest.impact.cards.card3.title")}
                  heading={t("demoRequest.impact.cards.card3.heading")}
                  description={t("demoRequest.impact.cards.card3.description")}
                  isHeading={true}
                />
              </div>
            </div>
          </section>
        </div>
      </Layout>
    </>
  );
};
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      pageData: "",
      pageTitle: "Request a Demo | Middleware",
      description:
        "Request a demo of Middleware’s cloud observability platform to optimize infrastructure and enhance user experience.",
      uri: "/demo-request/",
      ogImage: "/images/demo-request-thumbnail.png",
      metaTitle: "Request a Demo | Middleware",
      metaDesc:
        "Request a demo of Middleware’s cloud observability platform to optimize infrastructure and enhance user experience.",
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
      ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
    },
  };
};
export default DemoRequest;
